import { AppointmentCheck } from "@interfaces/search";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const appoimentCheck = createSlice({
    name: 'appoimentCheck',
    initialState: {
        time: 0,
        type: "",
        userRoleCode: "PR",
        username: "",
        teleconsultation: false
    } as AppointmentCheck,
    reducers: {
        setAppointmentChek: (state, action: PayloadAction<{time: number, type: string, userRoleCode: string, username: string, teleconsultation: boolean }>) => {
            state.time = action.payload.time
            state.type = action.payload.userRoleCode
            state.userRoleCode = action.payload.userRoleCode
            state.username = action.payload.username
            state.teleconsultation = action.payload.teleconsultation
        },
        cleanAppointmentCheck: (state) => {
            state.time = 0
            state.type = ""
            state.userRoleCode = ""
            state.username = ""
            state.teleconsultation = false
        }
    },
});

export const { setAppointmentChek, cleanAppointmentCheck } = appoimentCheck.actions;
export default appoimentCheck.reducer;